enum SortOrder {
  Asc = 'Asc',
  Desc = 'Desc',
}

export default SortOrder;
